import { uploadPostFile } from './postImages'

let job = null
const listeners = new Set()

export const getCreateUpload = () => job

export const subscribeCreateUpload = (listener) => {
  listeners.add(listener)
  listener(job)
  return () => listeners.delete(listener)
}

const setJob = (next) => {
  job = typeof next === 'function' ? next(job) : next
  listeners.forEach(fn => fn(job))
}

export const profileTabForUpload = (type) => {
  if (type === 'i') return 'i'
  if (type === 's' || type === 'a') return 's'
  return 'l'
}

export const clearCreateUpload = () => {
  if (job && job.previewUrl) URL.revokeObjectURL(job.previewUrl)
  setJob(null)
}

export const startCreateUpload = async ({ files, previewFile, title, type, publish }) => {
  if (job && (job.status === 'uploading' || job.status === 'publishing')) {
    throw new Error('An upload is already in progress.')
  }
  if (job && job.previewUrl) URL.revokeObjectURL(job.previewUrl)
  const list = (files || []).filter(Boolean)
  if (!list.length) throw new Error('No file to upload')
  const previewUrl = previewFile ? URL.createObjectURL(previewFile) : ''
  const sizes = list.map(file => Math.max(1, Number(file.size) || 1))
  const totalBytes = sizes.reduce((sum, size) => sum + size, 0)

  setJob({
    status: 'uploading',
    progress: 1,
    title: title || 'New post',
    type,
    previewUrl,
    error: ''
  })

  try {
    const names = []
    let doneBytes = 0
    for (let index = 0; index < list.length; index += 1) {
      const file = list[index]
      const name = await uploadPostFile(file, index, (pct) => {
        const loaded = doneBytes + (sizes[index] * pct)
        const progress = Math.max(1, Math.min(92, Math.round((loaded / totalBytes) * 92)))
        setJob(current => current && { ...current, status: 'uploading', progress })
      })
      names.push(name)
      doneBytes += sizes[index]
      setJob(current => current && { ...current, progress: Math.max(current.progress, Math.round((doneBytes / totalBytes) * 92)) })
    }
    setJob(current => current && { ...current, status: 'publishing', progress: 96 })
    await publish(names)
    setJob(current => current && { ...current, status: 'done', progress: 100 })
    window.setTimeout(() => {
      if (job && job.status === 'done') clearCreateUpload()
    }, 1200)
  } catch (err) {
    setJob(current => current && {
      ...current,
      status: 'error',
      error: err.message || 'Upload failed. Please try again.'
    })
    throw err
  }
}
